import { LOCALSTORAGENAME } from "../data/constants";

/**
 * Epic 82838: logout used to call localStorage.clear(), which also wiped the per-user UI
 * preferences that are meant to outlast a session - the grids' "Manage columns" selections
 * (Bug 78034) and the Post Interview list's remembered filters. Those entries are keyed per user
 * and hold layout/filter choices only, never tokens or personal data, so they are kept; every
 * other key (tokens, session, identity, impersonation) is still removed.
 */
const isUserPreferenceKey = (key: string): boolean =>
  key === LOCALSTORAGENAME.GRIDCOLUMNVISIBILITY || key.startsWith(`${LOCALSTORAGENAME.POSTIFHRFILTERS}:`);

/** localStorage.clear(), minus the per-user preference entries above. */
export const clearLocalStorageKeepingPreferences = (): void => {
  const kept: [string, string][] = [];
  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    const value = key === null ? null : localStorage.getItem(key);
    if (key !== null && value !== null && isUserPreferenceKey(key)) kept.push([key, value]);
  }
  localStorage.clear();
  kept.forEach(([key, value]) => localStorage.setItem(key, value));
};
